require("./gallery");

import "./popup/popup.scss";
import "../../gallery/widget.scss";
